import { useMemo } from 'react';

import { LoadingSpinner, Text } from '@kanda-libs/ks-design-library';

import { ChevronRight, FileText } from 'lucide-react';
import { formatToCurrency } from 'utils';

import { JobCustomQuoteLineItem } from './helpers';
import useJobQuoteItemCustom from './useJobQuoteItemCustom';

export interface JobQuoteItemCustomProps extends JobCustomQuoteLineItem {
  index: number;
  isLoading: boolean;
  compact: boolean;
}

const JobQuoteItemCustom: React.FunctionComponent<JobQuoteItemCustomProps> =
  function ({ id, price, title, index, isLoading, compact }) {
    const amount = useMemo(() => formatToCurrency(price), [price]);
    const {
      isSubmitting,
      onClick,
      headingClassName,
      buttonClassName,
      fileNameClassName,
      amountClassName,
    } = useJobQuoteItemCustom(id ?? '', compact);
    return (
      <>
        {index !== 0 && (
          <div className="border-b border-neutral-200 col-span-2" />
        )}
        <Text
          className={headingClassName}
          text="Quote PDF (click to view)"
          isLoading={isLoading}
        />
        <button
          type="button"
          onClick={() => {
            if (isSubmitting || isLoading) return;
            onClick();
          }}
          className={buttonClassName}
        >
          <FileText className="text-purple-400 my-auto" size={20} />
          {isSubmitting || isLoading ? (
            <LoadingSpinner size={16} className="m-auto" stroke="purple-400" />
          ) : (
            <span className={fileNameClassName}>{title}</span>
          )}
          <ChevronRight className="text-neutral-700 my-auto" size={20} />
        </button>
        <Text className={amountClassName} text={amount} isLoading={isLoading} />
      </>
    );
  };

export default JobQuoteItemCustom;
